const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 767,
    lg: 1025,
    xl: 1281,
  },
};

export default breakpoints;
